import * as theme from '../../theme';
import Heading from '../../components/Heading';
import { useNavigate } from "react-router";
import { costStructureList } from '../../contexts/CostStructureContext';

export default function CostStructure() {
  const navigate = useNavigate();

  function navigateBack() {
    navigate(`/dashboard`);
  }

  return (
    <div style={{ ...theme.Container.flexColumn.flexColumnContainer, ...theme.Container.center800 }}>
      <div style={theme.Container.flexColumn}>
        <Heading
          title={`Cost Structure`}
          onClick={() => navigateBack()}
        />
        <div style={{ ...theme.SubText2, paddingLeft: 10, paddingRight: 10 }}>
          List of items and their cost.
        </div>
      </div>
      <div style={theme.Container.fullMax}>
        <div style={theme.Container.flexOne}>
          {costStructureList.map((costStructure, index) => (
            <div key={index} style={{ padding: '0px 10px', marginBottom: 18 }}>
              <div style={{ fontWeight: 600, fontSize: 16, paddingBottom: 6 }}>{costStructure.label} - {costStructure.cost}</div>
              <div style={{ fontSize: 14, paddingBottom: 18, borderBottom: '1px solid #ccc' }}>{costStructure.description}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}